import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Typography,
	Card,
	CardContent,
	Grid,
	Tooltip,
	Avatar,
	Button,
} from '@material-ui/core';
import GroupIconGrid from '../components/GroupIconGrid';

import { usersList, getUserCount } from '../actions/usersActions';
import { UserBody } from '../types/UsersBody';
import UserReviewerGrid from '../components/UserReviewerGrid';

import { userGroupsList } from '../actions/userGroupsActions';
import ACL from '../../acl/components/ACL';

const styles = (theme: Theme) => createStyles({
	textCenter: {
		textAlign: 'center',
	},
	textCapitalize: {
		textTransform: 'capitalize'
	},
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	mb1x5x: {
		marginBottom: theme.spacing.unit * 1.5,
	},
	mr2x: {
		marginRight: theme.spacing.unit * 2,
	},
	cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},

	moreReviewers: {
		color: theme.palette.primary.main,
	},
	profileWrapper: {
		marginRight: theme.spacing.unit,
	},
	bigAvatar: {
		height: theme.spacing.unit * 7,
		width: theme.spacing.unit * 7,
	},
	roleName: {
		display: 'inline-block',
		textTransform: 'capitalize',
		marginRight: theme.spacing.unit / 2,
		'&:after': {
			content: '","',
		},
		'&:last-child': {
			marginRight: 0,
			'&:after': {
				display: 'none',
			}
		}
	},

	addRoleCard: {
		backgroundColor: fade(theme.palette.grey[400], 0.4),
		border: `2px dashed ${theme.palette.grey[500]}`,
	},
	addRoleCardImage: {
		opacity: 0.7,
	},
	addRoleCardName: {
		opacity: 0.7,
	},
	addRoleCardButton: {
		'& > button': {
			backgroundColor: theme.palette.common.white,
		}
	},
});

interface UsersContainerProps extends WithStyles<typeof styles> {
	users: UserBody[],
	usersList: Function,
	userGroupsList: () => void,
	getUserCount: () => void,
	handleButtonPress: (userId: string, e: any) => void,
	handleButtonRelease: () => void,
	handleDialogClose: () => void,
	handleShowUserProfile: (userProfile: any) => void,
	handleUserProfileClose: () => void,
	handleAssignDialogue: (isOpen: boolean) => void,
	assignRoleDialogOpen: boolean,
	selectedUserId: string,
	showUserProfile: boolean,
	selectedUserProfile: any,

}

interface UsersContainerState {

}

class UsersContainer extends Component<UsersContainerProps, UsersContainerState> {

	render() {
		const { classes, users, assignRoleDialogOpen, selectedUserId, showUserProfile, selectedUserProfile } = this.props;

		const AddRoleCard = ({ user }: any) => (
			<Card
				className={`${classes.mb1x5x} ${classes.addRoleCard}`}
				onClick={() => this.props.handleShowUserProfile(user)}
			>
				<CardContent className={classes.cardContentRoot}>
					<Grid container alignItems="center" spacing={8}>
						<Grid item xs="auto" className={`${classes.addRoleCardImage} ${classes.profileWrapper}`}>
							<Avatar alt={`Profile ${user.fullName}`} src={_.isEmpty(user.profileImage) ? "/assets/img/profile-default.png" : user.profileImage} className={classes.bigAvatar} />
						</Grid>
						<Grid item xs className={classes.addRoleCardName}>
							<Typography variant="h5" color="textSecondary">
								<strong className={classes.textCapitalize}>{user.fullName}</strong>
							</Typography>
						</Grid>

							<Grid item xs="auto" className={classes.addRoleCardButton}>
								<Button variant="contained" color="default"
									onClick={(e) => this.props.handleButtonPress(user._id, e)}
								>
									Add Role
							</Button>
							</Grid>
					</Grid>
				</CardContent>
			</Card>
		);

		const UserCard = ({ user }: any) => (
			<Card
				onClick={() => this.props.handleShowUserProfile(user)}
				className={classes.mb1x5x}
				onTouchStart={(e) => this.props.handleButtonPress(user._id, e)}
				onTouchEnd={this.props.handleButtonRelease}
				onMouseDown={(e) => this.props.handleButtonPress(user._id, e)}
				onMouseUp={this.props.handleButtonRelease}
				onMouseLeave={this.props.handleButtonRelease}>
				<CardContent className={classes.cardContentRoot}>
					<Grid container alignItems="center" spacing={8}>
						<Grid item xs="auto" className={classes.profileWrapper}>
							<Avatar alt={`Profile ${user.fullName}`} src={_.isEmpty(user.profileImage) ? "/assets/img/profile-default.png" : user.profileImage} className={classes.bigAvatar} />
						</Grid>

						<Grid item xs={7}>
							<Typography variant="h5">
								<strong className={classes.textCapitalize}>{user.fullName}</strong>
							</Typography>
							{_.map(user.roles, (role, rIndex) => (
								<Typography key={`role_${rIndex}`} variant="body1" className={classes.roleName}>

									{_.get(role, 'roleId.role', '')} for {!_.isUndefined(role.miniLibrary) && !_.isNull(role.miniLibrary) && role.miniLibrary.name}
								</Typography>
							))}
						</Grid>

						<Grid item xs className={classes.mr2x}>
							<UserReviewerGrid
								allReviewers={user.roles}
							/>
						</Grid>

						<Grid item xs="auto" className={classes.textCenter}>
							<GroupIconGrid
								groupColor={_.get(user, 'groupsId[0].groupColor', '')}
								groupName={_.get(user, 'groupsId[0].name', '')}
								otherGroups={user.groupsId}
							/>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		);

		return (
			<>
				{_.map(users, (user, uIndex) => (
					_.isEmpty(user.roles)
						? <AddRoleCard user={user} key={uIndex} />
						: <UserCard user={user} key={uIndex} />
				))}
			</>
		);
	}
	handleButtonPress(_id: any): ((event: React.MouseEvent<HTMLElement>) => void) | undefined {
		throw new Error("Method not implemented.");
	}
}

const mapStateToProps = (state: any) => ({
	users: _.get(state, 'userManagement.users.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	usersList,
	userGroupsList,
	getUserCount
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UsersContainer));